module.exports = __webpack_public_path__ + "ebe57c3de5cef36fa9c858899d8b6857.svg";